import { useAppDispatch } from "../../../../../redux/hooks";
import {
  fetchPrintBinA4,
  fetchPrintBinZebra,
} from "../../../../../redux/api/expedition.api";
import { UndeliveredBinsDataInterface } from "../../../../../redux/interfaces/expedition.interface";

import CustomButton from "../../../../../components/CustomButton";
import SvgIcon from "../../../../../helpers/SvgIcon";

function UndeliveredBinsActionButtons({
  itemId,
}: {
  itemId: string;
  crudData: UndeliveredBinsDataInterface;
}) {
  const dispatch = useAppDispatch();

  const handlePrintBinA4 = () => {
    if (itemId) {
      dispatch(
        fetchPrintBinA4({
          idBin: itemId,
        }),
      );
    }
  };

  const handlePrintBinZebra = () => {
    if (itemId) {
      dispatch(
        fetchPrintBinZebra({
          idBin: itemId,
        }),
      );
    }
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Print A4"
        onClick={handlePrintBinA4}>
        <SvgIcon type="PRINT_A4" fill="white" />
      </CustomButton>

      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Print Zebra"
        onClick={handlePrintBinZebra}>
        <SvgIcon type="PRINT_ZEBRA" />
      </CustomButton>
    </div>
  );
}

export default UndeliveredBinsActionButtons;
